module.exports = __webpack_public_path__ + "img/tw_map.13bbb8b8.png";